import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Play from '../Play';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import play from '../store/reducers/play';
import { getPlayState } from '../store/selectors/getPlayState';

initContainerData.register({
    reducers: { play }
});

const PlayDataContainer = ({
    dataIndex,
    showKeyMoments,
    openAtBatOverlay,
    ...otherProps
}) => {
    const {
        playData = {},
        teams = {},
        playVideoMap = {},
        keymoments,
        isLoading,
        deviceInteraction,
        language
    } = useSelector(getPlayState(dataIndex));

    const {
        resultPlayGuid
    } = playData;

    return (
        <Play
            { ...otherProps }
            playData={ playData }
            resultVideo={ playVideoMap[resultPlayGuid] }
            teams={ teams }
            keymoments={showKeyMoments ? keymoments : null}
            isLoading={ isLoading }
            language={ language }
            deviceInteraction={ deviceInteraction }
            openAtBatOverlay={openAtBatOverlay}
        />
    );
};

PlayDataContainer.propTypes = {
    dataIndex: PropTypes.number,
    showKeyMoments: PropTypes.bool
};

export default PlayDataContainer;
